import EditorDescriptor from "./EditorDescriptor";
import Button from "components/common/controls/Button";

interface Props {
  onContinueClick: () => void;
}

export default function SignUpSuccess(props: Props) {
  return (
    <EditorDescriptor title="Account Created">
      <div>
        <div className="mb-8 w-full">
          <div className="text-center">
            <div>Your phone number has been verified</div>
            <div>and your account is ready for use!</div>
          </div>
        </div>
        <Button
          text="Continue"
          className="w-full"
          onClick={props.onContinueClick}
        />
      </div>
    </EditorDescriptor>
  );
}
